// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import { art as ART_ENUM } from 'Enum';
import { Heading, Markdown, ExpandableOverflow } from '@riseart/common';
import { Wrapper } from '@riseart/layout';
import { Banner, getBannerMedia } from 'shared_components/common/banner/Banner';

import { categoryCls, categoryTitleCls } from './Category.less';

type CategoryProps = {
  id: number,
  image: Array<*>,
  title: string,
  description: string,
  minExpandedLength?: number,
  children?: any,
};

/**
 * Category
 *
 * @param {Props} props
 * @returns {React$Element<*>}
 */
export const Category = ({
  id,
  image = [],
  title,
  description,
  minExpandedLength = 100,
  children = null,
}: CategoryProps): React$Element<*> => {
  const { type: BANNER_IMAGE_TYPES } = ART_ENUM.category.image;

  return (
    <React.Fragment>
      {!isEmpty(image) ? (
        <Banner
          size="small"
          altTitle={title}
          artDirectionType="banner.fullWidth"
          artDirectionKey="common.banner"
          media={getBannerMedia(image, [], {
            small: BANNER_IMAGE_TYPES.TYPE_BANNER_SMALL,
            medium: BANNER_IMAGE_TYPES.TYPE_BANNER_MEDIUM,
            large: BANNER_IMAGE_TYPES.TYPE_BANNER_LARGE,
          })}
        />
      ) : null}
      {children ? <Wrapper>{children}</Wrapper> : null}
      {title || description ? (
        <Wrapper
          sizes={{
            xs: 'wide',
            sm: 'wide',
            md: 'wide',
            lg: 'narrow',
            xl: 'narrow',
          }}
          className={categoryCls}
        >
          {title ? (
            <Heading tag="h1" level="3" className={categoryTitleCls}>
              {title}
            </Heading>
          ) : null}

          {description ? (
            <ExpandableOverflow
              maxHeight={minExpandedLength}
              gradientColor="gray"
              showMore={<FormattedMessage id="common.show_more" />}
              showLess={<FormattedMessage id="common.show_less" />}
            >
              <Markdown key={id} text={description} />
            </ExpandableOverflow>
          ) : null}
        </Wrapper>
      ) : null}
    </React.Fragment>
  );
};
